module.exports = __webpack_public_path__ + "media/top/bubble_1-1f96511a.svg";